import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FormFieldComponent} from './components/form-field.component';

// import {FeedbackComponent} from './pre-built/control/feedback.pre-built';
import {FormComponent} from './form.component';

import {SubmitDirective} from './directives/submit.directive';
// import {DynamicFieldDirective} from './directives/dynamic-field.directive';
// import {ControlContentDirective} from './directives/control-content.directive';
import {FormLabelComponent} from './components/form-label.component';
import {FormControlDirective} from './directives/form-control.directive';

import {RenderControlDirective} from './directives/render-control.directive';
import {FormControlComponent} from './components/form-control.component';
import {FormFeedbackComponent} from './components/form-feedback.component';


import {FormComponentsModule} from "./components/form-components.module";


@NgModule({
    declarations: [
        
        ////////////-------------                     Components                     -------------  ////////////
        
        FormComponent,
        FormFieldComponent, FormLabelComponent, FormControlComponent, FormFeedbackComponent,
        
        
        ////////////-------------                     Directives                     -------------  ////////////
        RenderControlDirective,
        
        SubmitDirective, FormControlDirective
    ],
    
    imports: [
        CommonModule,
        FormComponentsModule
    ],
    exports: [
        
        ////////////-------------                     Components                     -------------  ////////////
        
        FormComponent,
        
        FormControlComponent, FormFieldComponent, FormLabelComponent, FormFeedbackComponent,
        
        ////////////-------------                     Directives                     -------------  ////////////
        
        SubmitDirective, FormControlDirective,
        
        
        FormComponentsModule
    ]
})
export class AzoraFormModule {
}
